import {isNullOrUndefined} from "../../services/Validator";

export default function SystemTopBarLayout({children, extraClass}) {
    // Used through the app to frame top bar in mobile mode

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={"bg-backgroundLight1 w-full h-[64px] lg:h-[72px] min-h-[64px] lg:min-h-[72px] max-h-[64px] lg:max-h-[72px] flex justify-between items-center px-[24px] lg:px-[32px] " + extraClass}>
            {children}
        </div>
    );
}